import { gql } from '@apollo/client';

export const DELETE_SUPPLIER = gql`
  mutation deleteSupplier($id: ID!) {
    deleteSupplier(id: $id)
  }
`;
